import { createSlice } from '@reduxjs/toolkit';
import { AutocompleteType, SearchStatus } from '../../constants';

const initialState = {
  destinationsAutocompleteResults: [],
  flightOriginAutocompleteResults: [],
  airportsAutocompleteResults: [],
  cruiseLinesAutocompleteResults: [],
  cruiseShipsAutocompleteResults: [],
  portOfDepartureAutocompleteResults: [],
  citiesAutocompleteResults: [],
  tourAutocompleteResults: [],
  autocompleteCache: {}, // {[url]: data}
  hotelAutocompleteRequestStatus: SearchStatus.INITIAL,
};

// Helper function to check if autocomplete types are for hotels
const isHotelAutocomplete = (types) => Array.isArray(types) && AutocompleteType.HOTELS
  .every((code) => types.includes(code));

const autocompleteDetailsHandle = (state, { payload: { responseType, data } }) => ({
  ...state,
  [responseType]: data,
  hotelAutocompleteRequestStatus: responseType && responseType.payload
    && isHotelAutocomplete(responseType.payload.autocompleteTypes)
    ? SearchStatus.DONE : undefined,
});

const autocompleteSlice = createSlice({
  name: 'autocomplete',
  initialState,
  reducers: {
    autocompleteRequest: (state) => state,
    hotelAutocompleteRequest: (state, action) => ({
      ...state,
      hotelAutocompleteRequestStatus: action && action.payload
        && isHotelAutocomplete(action.payload.autocompleteTypes)
        ? SearchStatus.SEARCHING : undefined,
    }),
    autocompleteSuccess: (state, action) => autocompleteDetailsHandle(state, action),
    defaultAutocompleteSucess: (state, { payload }) => {
      const newState = { ...state };
      payload.forEach(({ responseType, data }) => {
        newState[responseType] = data.groups;
      });
      return newState;
    },
    autocompleteFail: (state, action) => autocompleteDetailsHandle(state, action),
    clearAutocomplete: (state, { payload }) => ({
      ...state,
      [payload.responseType]: [],
    }),
    cacheAutocompleteResponse: (state, action) => ({
      ...state,
      autocompleteCache: {
        ...state.autocompleteCache,
        [action.payload.url]: action.payload.responseData,
      },
    }),
  },
});

export const {
  autocompleteRequest,
  hotelAutocompleteRequest,
  autocompleteSuccess,
  autocompleteFail,
  clearAutocomplete,
  cacheAutocompleteResponse,
  defaultAutocompleteSucess,
} = autocompleteSlice.actions;
export default autocompleteSlice.reducer;
